<template>
	<el-row>
		<el-col :span="24" class="pagination-container">
			<el-pagination
				style="margin-top: 8px"
				@size-change="sizeChangeHandler"
				@current-change="currentChangeHandler"
				:current-page="pageIndex_p"
				:page-size="pageSize_p"
				layout="total, sizes, prev, pager, next, jumper"
				v-bind="$attrs"
				v-on="$listeners"
			></el-pagination>
		</el-col>
	</el-row>
</template>

<script>
export default {
	inheritAttrs: false,
	props: ['pageIndex_p', 'pageSize_p'],
	data() {
		return {};
	},
	methods: {
		sizeChangeHandler(val) {
			this.$emit('update:pageSize_p', val);
		},
		sizeChangeHandler1(val) {
			// 通过 $parent 获取 total 值
			const { total } = this.$parent;

			// 如果获取到 total 值，则计算最优页码
			if (total) {
				const currentStartIndex = (this.pageIndex_p - 1) * this.pageSize_p;
				let targetPage = Math.floor(currentStartIndex / val) + 1;
				const maxPage = Math.ceil(total / val);
				targetPage = Math.max(1, Math.min(targetPage, maxPage));

				this.$emit('update:pageIndex_p', targetPage);
			} else {
				// 否则默认回到第一页
				this.$emit('update:pageIndex_p', 1);
			}

			this.$emit('update:pageSize_p', val);
		},
		currentChangeHandler(val) {
			// console.log(`当前页: ${val}`);
			this.$emit('update:pageIndex_p', val);
		}
	}
};
</script>

<style scoped lang="less">
.pagination-container {
	margin-top: 20px;
	text-align: right;
}
</style>
